import { i18n } from "./init";
/** The stable `code` a backend exception body carries, if any. */
export const backendErrorCode = (error) => {
    const code = error?.response?.data?.error?.code;
    return typeof code === "string" && code ? code : undefined;
};
/**
 * The UI copy for a backend error code: `errors:<code>` (or
 * `errors:<group>.<code>`), the group's generic message when the code is
 * missing or has no key. Never the backend's English sentence.
 */
export const errorMessage = (code, group) => {
    const prefix = group ? `errors:${group}.` : "errors:";
    const translate = i18n.t;
    /* A gate code (sign-in, daily cap) has one copy at the top level that every
       group shares, so the group's own key is tried first and that one second. */
    const key = [`${prefix}${code}`, `errors:${code}`].find((candidate) => code && i18n.exists(candidate));
    return translate(key ?? `${prefix}generic`);
};
//# sourceMappingURL=errorMessage.js.map